import { render, staticRenderFns } from "./ChannelNavTabs.vue?vue&type=template&id=32bf2a48&"
import script from "./ChannelNavTabs.vue?vue&type=script&lang=js&"
export * from "./ChannelNavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports